import React from 'react';

import { Link } from 'react-router';
import type { BrainAtlasType, MultiLang } from '../../../config';
import Functions from '../../../functions';
import ItemUtil, { type ItemSubTypesAll } from '../../lib/ItemUtil';

export interface TopBaseProps {
    lang: MultiLang;
    type: BrainAtlasType;
}

class TopBase extends React.Component<TopBaseProps> {
    protected type = '';
    protected label = '';
    protected icon = '';
    protected description = '';
    protected subTypes: ItemSubTypesAll = [];

    render() {
        const { lang, type } = this.props;
        const url = ItemUtil.getItemTypeSearchUrl(type, this.type, '');
        const links = this.subTypes.map((subtype, i) => {
            const url = ItemUtil.getItemTypeSearchUrl(type, this.type, subtype.type);
            return (
                <React.Fragment key={subtype.type}>
                    {i > 0 && ' / '}
                    <Link to={url}>{subtype.label}</Link>
                </React.Fragment>
            );
        });
        return (
            <div>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <img src={this.icon} alt={this.label} />
                            </td>
                            <td className="itemTypeName">
                                <Link to={url}>{this.label}</Link>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <hr />
                <div>{Functions.mlang(this.description, lang)}</div>
                {links}
            </div>
        );
    }
}

export default TopBase;
